import { render, staticRenderFns } from "./ModelPreview.vue?vue&type=template&id=3b63be44&scoped=true"
import script from "./ModelPreview.vue?vue&type=script&lang=js"
export * from "./ModelPreview.vue?vue&type=script&lang=js"
import style0 from "./ModelPreview.vue?vue&type=style&index=0&id=3b63be44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b63be44",
  null
  
)

export default component.exports